<mat-card>
    <mat-card-content>
        <app-registrations-table></app-registrations-table>
    </mat-card-content>
</mat-card>
